/**
 * Extract plain text from HTML string with line breaks preserved
 * Removes all HTML tags and returns the text content
 * Handles both raw HTML and escaped HTML entities
 * @param {string} htmlString - HTML string (e.g., from Quill editor)
 * @returns {string} Plain text without HTML tags or formatting
 */
export function htmlToPlainText(htmlString) {
  if (!htmlString) return '';

  try {
    // Create a temporary DOM element
    const tempDiv = document.createElement('div');

    // Set innerHTML to parse the HTML (also unescapes HTML entities)
    tempDiv.innerHTML = htmlString;

    // Convert all <p>, <li>, <div>, and <br> to line breaks for structure
    // Process the DOM to replace block elements with newlines
    const processNode = (node) => {
      let text = '';

      for (let child of node.childNodes) {
        if (child.nodeType === 3) { // Text node
          text += child.textContent;
        } else if (child.nodeType === 1) { // Element node
          const tagName = child.tagName.toLowerCase();

          // Recursively process children
          text += processNode(child);

          // Add newline after block elements
          if (['p', 'div', 'li', 'br'].includes(tagName)) {
            text += '\n';
          }
        }
      }

      return text;
    };

    // Get text content, preserving structure
    let result = processNode(tempDiv);

    // Clean up: remove multiple consecutive newlines, trim whitespace
    result = result
      .replace(/\n\n+/g, '\n') // Multiple newlines → single newline
      .trim();

    return result;
  } catch (error) {
    // Fallback: simple regex-based extraction
    console.warn('htmlToPlainText error, using fallback:', error);
    return htmlString
      .replace(/<[^>]*>/g, '') // Remove all HTML tags
      .trim();
  }
}
